<template>
  <div>
    <ReportPage
      v-if="type == 'ReportPage'"
      @resize="$emit('resize', $event)"
      :src="src"
      :parentOffset="parentOffset"
    />
    <ReportTitleBand
      v-if="type == 'ReportTitleBand'"
      @resize="$emit('resize', $event)"
      :src="src"
      :parentOffset="parentOffset"
    />
    <DataHeaderBand
      v-if="type == 'DataHeaderBand'"
      @resize="$emit('resize', $event)"
      :src="src"
      :parentOffset="parentOffset"
    />
    <DataBand
      v-if="type == 'DataBand'"
      @resize="$emit('resize', $event)"
      :src="src"
      :parentOffset="parentOffset"
    />
    <ReportTitleBand
      v-if="type == 'ReportTitleBand'"
      @resize="$emit('resize', $event)"
      :src="src"
      :parentOffset="parentOffset"
    />
    <LineObject
      v-if="type == 'LineObject'"
      @resize="$emit('resize', $event)"
      :src="src"
      :parentOffset="parentOffset"
    />
    <TextObject
      v-if="type == 'TextObject'"
      @resize="$emit('resize', $event)"
      :src="src"
      :parentOffset="parentOffset"
    />
    <PictureObject
      v-if="type == 'PictureObject'"
      @resize="$emit('resize', $event)"
      :src="src"
      :parentOffset="parentOffset"
    />
    <PageFooterBand
      v-if="type == 'PageFooterBand'"
      @resize="$emit('resize', $event)"
      :src="src"
      :parentOffset="parentOffset"
    />
  </div>
</template>
<script>
import ReportPage from "./ReportPage.vue";
import DataHeaderBand from "./DataHeaderBand.vue";
import DataBand from "./DataBand.vue";
import PageFooterBand from "./PageFooterBand.vue";
import ReportTitleBand from "./ReportTitleBand.vue";
import LineObject from "./LineObject.vue";
import TextObject from "./TextObject.vue";
import PictureObject from "./PictureObject.vue";

export default {
  name: "CollectorComponents",
  props: {
    src: Object,
    parentOffset: Object,
    type: String,
    zoom: {
      type: Number,
      default: 100,
    },
  },
  components: {
    ReportPage,
    DataBand,
    DataHeaderBand,
    PageFooterBand,
    ReportTitleBand,
    LineObject,
    TextObject,
    PictureObject,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>
<style scoped>
</style>
